import { inheritsLoose as _inheritsLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _toPairs from 'lodash/toPairs';
import { withTheme } from 'styled-components';
import { TooltipPopper, Tooltip, Heading, Paragraph, TriggerText } from '@zillow/constellation';
import withDimensions from './withDimensions.js';
import PropInterpolatorWrapper from './Chart/common/PropInterpolator.js';
import DonutChart from './DonutChart.js';
import { getWholeDollars } from '../../utils/zhl-calculator.js';

var _PaymentDonutChart;
var MonthlyPITooltip = /*#__PURE__*/React.createElement(TooltipPopper, {
  generateDescribedBy: false,
  triggered: /*#__PURE__*/React.createElement(Tooltip, {
    role: "tooltip",
    "aria-describedby": null,
    body: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
      level: "4"
    }, "Principal and Interest"), /*#__PURE__*/React.createElement(Paragraph, null, "Your mortgage principal is the total amount you've borrowed from a lender to buy a home. Interest is the fee lenders charge you for borrowing their money; usually, an annual percentage rate."))
  })
}, /*#__PURE__*/React.createElement(TriggerText, {
  as: "text",
  role: "button",
  tabIndex: "0",
  "aria-haspopup": "false"
}, "P & I"));
var PaymentDonutChart = withTheme((_PaymentDonutChart = /*#__PURE__*/function (_Component) {
  function PaymentDonutChart() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.colors = function (i) {
      return [_this.props.theme.constellation.colors.blue400, _this.props.theme.constellation.colors.blue500, _this.props.theme.constellation.colors.blue600, _this.props.theme.constellation.colors.blue300, _this.props.theme.constellation.colors.blue200][i] || _this.props.theme.constellation.colors.black;
    };
    return _this;
  }
  _inheritsLoose(PaymentDonutChart, _Component);
  var _proto = PaymentDonutChart.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var nameMap = {
      monthlyPI: MonthlyPITooltip,
      monthlyPropertyTax: 'Taxes',
      monthlyHomeownersInsurance: 'Insurance',
      monthlyPMI: 'PMI',
      monthlyHOA: 'HOA',
      monthlyMIP: this.props.monthlyMIP ? 'MIP' : ''
    };
    var usedColorsList = [];
    var getColors = function getColors(i) {
      return usedColorsList[i] || _this2.props.theme.constellation.colors.black;
    };
    var chartData = _toPairs(this.props).filter(function (item) {
      return !!nameMap[item[0]];
    }).map(function (item) {
      return {
        label: nameMap[item[0]],
        value: Math.round(item[1])
      };
    }).filter(function (element, i) {
      if (element.value > 0) {
        usedColorsList.push(_this2.colors(i));
        return true;
      }
      return false;
    });
    var constrainedDimension = 140;
    var radiusRatio = 2.25;
    var height = 140;
    if (!this.props.hideLabels) {
      constrainedDimension = Math.min(this.props.containerWidth, 275) - 30; // For label margin
      radiusRatio = 3;
      height = 275;
    }
    return /*#__PURE__*/React.createElement("div", {
      style: {
        height: height
      }
    }, /*#__PURE__*/React.createElement(DonutChart, {
      data: chartData,
      width: this.props.containerWidth,
      height: height,
      radius: constrainedDimension / radiusRatio,
      innerRadius: constrainedDimension / radiusRatio * 0.87,
      valueFormatter: getWholeDollars,
      centerText: "Your payment",
      colors: getColors,
      hideLabels: this.props.hideLabels,
      smallCenterLabel: this.props.smallCenterLabel,
      centerValue: Math.round(this.props.monthlyPayment)
    }));
  };
  return PaymentDonutChart;
}(Component), _PaymentDonutChart.propTypes = {
  monthlyPayment: PropTypes.number,
  containerWidth: PropTypes.number,
  hideLabels: PropTypes.bool,
  smallCenterLabel: PropTypes.bool,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  theme: PropTypes.object
}, _PaymentDonutChart));

// Default height & width are the dimensions of the payment donut chart as rendered on an iPhone X, our most
// common device type according to GA data as of 10/5/2021
var PaymentDonutChart$1 = PropInterpolatorWrapper(withDimensions(PaymentDonutChart, {
  defaultHeight: 275,
  defaultWidth: 347
}));

export { PaymentDonutChart$1 as default };
